import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Button from './Button';
import Group from '../Group/Group';

export default class ButtonExample extends Component {

  state = {
    iconName: 'play',
  };

  onChange = e => this.setState(e.target.value);

  onClick = () => window.showAppInfo('button');

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Button.defaultProps} propTypes={Button.propTypes} propValues={this.state}>
          <Tip><em>inProgress</em> prop is still in development</Tip>
        </Properties>
        <Group>
          <Group className="sub-group">
            <Button {...this.state} onClick={this.onClick}>Button</Button>
          </Group>
          <Group className="sub-group" title="Class: primary, secondary and tertiary">
            <Button {...this.state} className="primary" iconName="">Primary button</Button>
            <Button {...this.state} className="" iconName="">Secondary button</Button>
            <Button {...this.state} className="tertiary" iconName="">Tertiary button</Button>
          </Group>
          <Group className="sub-group" title="Class: core-icon-button">
            <Button {...this.state} className="core-icon-button primary" iconName="add"/>
            <Button {...this.state} className="core-icon-button" iconName="edit"/>
            <Button {...this.state} className="core-icon-button tertiary" iconName="download"/>
          </Group>
        </Group>
        <SourceCode querySelector=".button-example .example .core-button"/>
      </Example>
    );
  }

}
